












import Vue, { PropType } from 'vue'

import { MessageChannel } from 'base/store/state.interface'

import { ChatLayout } from '../layout/chat-layout.interface'
import { DraggedChatElement } from './dragged-chat-element.interface'
import MessengerDropContainer from './MessengerDropContainer.vue'

export default Vue.extend({
  components: {
    MessengerDropContainer
  },
  props: {
    layout: {
      type: Object as PropType<ChatLayout>,
      required: true
    },
    channels: {
      type: Array as PropType<MessageChannel[]>
    },
    selectedChannel: {
      type: Object as PropType<MessageChannel | undefined>,
      default: undefined
    }
  },
  data() {
    return {
      draggedChat: null as DraggedChatElement | null
    }
  },
  computed: {
    channelCollections(): { [id: number]: MessageChannel[] } {
      return this.$store.state.messenger.layout.channelCollection
    }
  },
  methods: {
    async chatDragged(event: DragEvent, channel: MessageChannel) {
      if (!event.srcElement || this.draggedChat) return

      const domElement = event.srcElement as HTMLElement
      const domElementHeight = domElement.offsetHeight
      this.draggedChat = {
        channel,
        domElement,
        domElementHeight
      }

      // Remove dragged element from column
      void this.$store.dispatch('setRemoveChannelFromCollection', this.draggedChat.channel)
    },
    async chatDropped(event: DragEvent, columnId: number, index: number) {
      if (!this.draggedChat) return

      const droppedColumn = this.layout.columns[columnId]

      // Prevent clones of selected channel in primary column
      if (this.selectedChannel && this.draggedChat.channel.id === this.selectedChannel.id && droppedColumn.isPrimary) {
        this.draggedChat = null
        return
      }

      await this.$store.dispatch('moveChannelToColumn', {
        channel: this.draggedChat.channel,
        columnId: columnId,
        indexInColumn: index
      })

      this.draggedChat = null
    },
    chatDragend(event: DragEvent) {
      if (!this.draggedChat) return

      this.draggedChat = null
    },
    channelsForColumn(columnId: number): MessageChannel[] {
      const columnConfig = this.layout.columns[columnId.toString()]
      if (!columnConfig) return []

      const channels = this.channelCollections[columnId.toString()]

      if (columnConfig.isPrimary && this.selectedChannel) {
        return [this.selectedChannel, ...channels]
      }
      return channels
    }
  }
})
